import MessageDialog from '@/components/MessageDialog.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { createConfirmDialog } from 'vuejs-confirm-dialog'
import Router from '../router'
import Store from '../store';

function showError(message) {
    const { reveal, onConfirm } = createConfirmDialog(MessageDialog, { mode: 'ERROR', message });

    return new Promise(resolve => {
        reveal();
        onConfirm(resolve);
    })
}

function showInfo(message) {
    const { reveal, onConfirm } = createConfirmDialog(MessageDialog, { mode: 'INFO', message });

    return new Promise(resolve => {
        reveal();
        onConfirm(resolve);
    })
}

function showWarning(message) {
    const { reveal, onConfirm } = createConfirmDialog(MessageDialog, { mode: 'WARNING', message });

    return new Promise(resolve => {
        reveal();
        onConfirm(resolve);
    })
}

function confirmDialog(message) {
    const { reveal, onConfirm, onCancel } = createConfirmDialog(ConfirmDialog, { message });

    return new Promise(resolve => {
        reveal();
        onConfirm(() => resolve(true));
        onCancel(() => resolve(false));
    })
}

function showException(except, message) {
    if (except.errorCode === 500) {
        Store.commit('SET_ERROR', except.message);
        Router.push('/ERROR');
        return;
    }

    if (except.errorCode === 403) {
        // showError(except.message)
        // .then(() => {
            Store.commit('CLEAR_USER');
            Router.push('/Login');
        // });
        return;
    }

    const msg = message || except.message;
    return showError(msg);
}

export default {
    showError,
    showInfo,
    showWarning,
    confirmDialog,
    showException
};
